<template>
  <div class="pagination-div">
    <v-btn
      class="ma-2 page-arrow-size"
      outlined
      color="#707070"
      @click="changePage('prev')"
      :disabled="currentPage === 1 || loading"
    >
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>
    <v-btn class="page-count-size" outlined color="#c9242b">
      {{ currentPage }}
    </v-btn>
    <v-btn
      class="ma-2 page-arrow-size"
      outlined
      color="#707070"
      @click="changePage('next')"
      :disabled="currentPage === totalPages || loading || totalPages == 0"
    >
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>
    <!-- <span v-if="!loading">{{ displayRange }}</span> -->
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  props: ["collectionName"],
  computed: {
    ...mapState({
      loading(state) {
        return state[this.collectionName].loading;
      },
      docsOrigin: (state) => state.docs.listOrigin,
      keyword: (state) => state.docs.keyword,
      valueFilterList: (state) => state.docs.valueFilterList,
      orderBySelect: (state) => state.docs.orderBySelect,
    }),
    totalPages() {
      return Math.ceil(this.docsOrigin.length / this.itemsPerPage);
    },
    displayRange() {
      const start = (this.currentPage - 1) * this.itemsPerPage + 1;
      const end = Math.min(
        start + this.itemsPerPage - 1,
        this.docsOrigin.length
      );
      return `${start} - ${end} จาก ${this.docsOrigin.length}`;
    },
  },
  data() {
    return {
      itemsPerPage: parseInt(localStorage.getItem("pageLimit")) || 10,
      currentPage: 1,
    };
  },
  methods: {
    ...mapActions({
      updateDocs: "docs/updateDocs", // Assuming 'updateDocs' is the action name
    }),
    changePage(direction) {
      if (direction === "prev" && this.currentPage > 1) {
        this.currentPage -= 1;
      } else if (direction === "next" && this.currentPage < this.totalPages) {
        this.currentPage += 1;
      }

      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      const paginatedDocs = this.docsOrigin.slice(start, end);

      this.updateDocs(paginatedDocs);
    },
  },
  watch: {
    orderBySelect: {
      handler: function () {
        this.currentPage = 1;
      },
    },
    valueFilterList: {
      handler: function () {
        this.currentPage = 1;
      },
    },
    keyword: {
      handler: function () {
        this.currentPage = 1;
      },
    },
  },
};
</script>
